import { EXERCISE_LOG_SUMMARY_KEY } from '../../constants'
import { isEmptyUtil } from 'packages/src'

function beforeSaveExerciseLogSummaryHook (data) {
  let updates = {}
  const oneRepMax = data[EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX]
  if (oneRepMax != null) {
    updates = {
      [EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX]: parseFloat(
        oneRepMax
      )
    }
  }

  if (isEmptyUtil(updates)) {
    return data
  }

  return {
    ...data,
    ...updates
  }
}

export default beforeSaveExerciseLogSummaryHook
